import React from 'react';
import { Link } from '@fiverr-private/typography';

interface Props {
    children: React.ReactNode;
    href: string;
}

export const DisclaimerLink = ({ children, href }: Props) => (
    <Link decoration="underline" color="green_900" href={href} target="_blank" rel="noreferrer noopener">
        {children}
    </Link>
);
